/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum ExpiryHandlingStrategyV3 {
    SKIP = 'SKIP',
    ABORT = 'ABORT'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const ExpiryHandlingStrategyV3ValidatorShape = [
    'SKIP',
    'ABORT'
];
export const ExpiryHandlingStrategyV3Validator = yup.mixed().oneOf(ExpiryHandlingStrategyV3ValidatorShape);
export const ExpiryHandlingStrategyV3StringifyShapeProperties = {};
export const ExpiryHandlingStrategyV3StringifyShape: StringSchema = {
    title: 'ExpiryHandlingStrategyV3 Stringifier',
    type: 'string'
};
export const ExpiryHandlingStrategyV3Stringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(ExpiryHandlingStrategyV3StringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function ExpiryHandlingStrategyV3FromJSON(json: any): ExpiryHandlingStrategyV3 {
    return ExpiryHandlingStrategyV3FromJSONTyped(json, false);
}
export function ExpiryHandlingStrategyV3FromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpiryHandlingStrategyV3 {
    return json as ExpiryHandlingStrategyV3;
}
export function ExpiryHandlingStrategyV3ToJSON(value?: ExpiryHandlingStrategyV3 | null): any {
    return value as any;
}
